module.exports = __webpack_public_path__ + "img/pe04.5838ae1c.jpg";